module.exports = __webpack_public_path__ + "static/media/Vector_Smart_Object_copy_7_gowfnr.44469823.png";